import { io, Socket } from 'socket.io-client';
import { ClientToServerEvents, ServerToClientEvents } from './socket.types';
import { environment } from '../environments/environment';

class SocketService {
    private static instance: any;

    public socket: Socket<ServerToClientEvents, ClientToServerEvents> | null = null;

    public accessToken: string = '';

    public subscribedTopics;

    private constructor() {
        this.subscribedTopics = new Set();
    }

    public static getInstance(): SocketService {
        if (!SocketService.instance) {
            SocketService.instance = new SocketService();
        }
        return SocketService.instance;
    }

    public connect(token: string): void {
        this.accessToken = token;
        const authUrl = `${environment.SOCKET_URL}`;
        console.warn('this.socket in connect', this.socket);
        if (!this.socket) {
            this.socket = io(authUrl, {
                transports: ['websocket'],
                autoConnect: true,
                auth: {
                    token: `Bearer ${token}`,
                },
            });

            this.socket.connect();
            this.socket.on('connect', () => {
                console.warn('Socket connected:', this.socket?.id);
            });

            this.socket.on('disconnect', () => {
                console.warn('Socket disconnected');
            });
        }
    }

    public disconnect(): void {
        if (this.socket) {
            if (this.socket.connected) {
                this.socket.disconnect();
            }
            this.socket = null;
        }
    }

    public on<Event extends keyof ServerToClientEvents>(event: Event, listener: ServerToClientEvents[Event]) {
        this.socket?.on(event, listener as any);
        this.subscribedTopics.add(event);
    }

    public off<Event extends keyof ServerToClientEvents>(event: Event, listener?: ServerToClientEvents[Event]) {
        this.socket?.off(event, listener as any);
    }

    public emit<Event extends keyof ClientToServerEvents>(
        event: Event,
        ...args: Parameters<ClientToServerEvents[Event]>
    ) {
        this.socket?.emit(event, ...args);
    }

    public isConnected(): boolean {
        return !!this.socket?.connected;
    }

    getSubscribedTopics() {
        return Array.from(this.subscribedTopics); // Return list
    }
}

const WSInstance = SocketService.getInstance();

export { WSInstance };
